import { Close } from '@mui/icons-material';
import { Box, Button, Divider, Modal, Typography } from '@mui/material';
import styles from './styles';

interface IApplyAltDescriptionModalProps {
  isOpen: boolean;
  itemName: string;
  newValue: string | null;
  handleClose: () => void;
  handleApplyToThisOnly: () => void;
  handleApplyToAll: () => void;
}

/**
 * Component that asks whether a rename or reset of an ineligible setting's alternative
 * description should apply to every collateral under the client, or just the currently
 * selected collateral.
 * @param props The component's props.
 * @returns The rendered component.
 */
export const ApplyAltDescriptionModal = (props: IApplyAltDescriptionModalProps) => {
  const isReset = props.newValue === null;

  return (
    <Modal open={props.isOpen}>
      <Box sx={styles.modalBackground}>
        <Box sx={styles.headingContainer}>
          <Typography sx={styles.headingTitle}>{isReset ? 'Reset Confirmation' : 'Rename Confirmation'}</Typography>
          <Close fontSize='small' onClick={props.handleClose} sx={styles.closeButton} aria-label='Close icon' />
        </Box>
        <Divider sx={styles.divider} />
        <Typography sx={styles.messageText}>
          { isReset
            ? `Reset "${props.itemName}" back to its default name for all collaterals under this client, or only for the currently selected collateral?`
            : `Rename "${props.itemName}" to "${props.newValue}" for all collaterals under this client, or only for the currently selected collateral?`
          }
        </Typography>
        <Divider sx={styles.divider} />
        <Box sx={styles.rightButtonsContainer}>
          <Button variant='outlined' sx={styles.cancelButton} onClick={props.handleApplyToThisOnly}>
            This collateral only
          </Button>
          <Button variant='contained' sx={styles.okayButton} onClick={props.handleApplyToAll}>
            Apply to all
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
